import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./styles.scss";
// import { Autoplay } from "swiper";
// import CouponItem from "../Coupons/item";
// import Title from "../Title";
// import { fetchData } from "../../utils/helper";
import clsx from "clsx";
import Image from "../shared/Image";
import { InView } from "react-intersection-observer";
import loader1 from "../../images/loader1.svg"; // https://codepen.io/nikhil8krishnan/pen/rVoXJa
import { ReactSVG } from "react-svg";

const SwiperDataFeedReader = (props) => {
  const userID = "3585269";
  const {
    filename,
    title,
    // logo,
    // bgColor,
    // theme,
    name,
    // preferredWidth,
    // preferredHeight,
    type,
    // dataFeedType = "",
    merchantId = "",
    isShareUrl,
  } = props;
  const [tableData, setTableData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const pageSize = 12;
  const [items, setItems] = useState([]);
  const [loadCount, setLoadCount] = useState(pageSize);
  const [lastIndex, setLastIndex] = useState(0);

  const loadItems = () => {
    fetch(filename)
      .then((response) => response.text())
      .then((text) => {
        const lines = text?.trim()?.split("\n");
        const headers = lines?.[0]?.split("|");
        const data = lines?.slice(1).map((line) => line?.split("|"));
        const formattedData = data?.map((line) => {
          const row = {};
          headers?.forEach((header, i) => {
            row[header] = line?.[i];
          });
          return row;
        });

        const nextIndex = lastIndex + pageSize;
        const hasNext = nextIndex < data.length;

        setHasMore(hasNext);
        setItems(formattedData.slice(0, loadCount));
        setLoadCount(loadCount + pageSize);
        setLastIndex(loadCount + pageSize);
      });
  };

  useEffect(() => {
    const fetchDataLocal = async () => {
      let formattedData = await loadItems();
      setTableData(formattedData);
    };
    fetchDataLocal();
  }, [filename]);

  if (!Array.isArray(items) || items?.length <= 0) {
    return (
      <div className="svg-loader-wrap flex-it flex-align-item-center flex-justify-center">
        <ReactSVG src={loader1} className="svg-loader" />
      </div>
    );
  } else
    return (
      Array.isArray(items) &&
      items?.length > 0 &&
      !!items && (
        <>
          <div className="title-of-coupons">{title}</div>
          <div
            className={clsx(
              "SwiperDataFeedReader coupons m-top-0",
              `type-${type}`
            )}
          >
            {type === "listing" ? (
              items?.map((item, index) => {
                const img = item?.["Image Url"];

                // const number = img?.split("/")?.[0];
                const link = isShareUrl
                  ? `https://www.shareasale.com/m-pr.cfm?merchantID=${merchantId}&userID=${userID}&productID=${item?.Id}`
                  : item?.link?.replaceAll("YOURUSERID", userID);
                const price = item?.Price;
                const Name = item?.Name;
                return (
                  <a
                    key={index}
                    target="_blank"
                    rel="noreferrer"
                    className="link-to-product"
                    href={link}
                  >
                    <div className="item-image">
                      <Image allt={Name} src={img} />
                    </div>
                    <div className="data-list-wrap">
                      <div className="data-title">
                        <span>{Name}</span>
                      </div>
                      <div className="data-price">
                        <u>Price:</u> <span>{price}$</span>
                      </div>
                    </div>
                    <div className="checkout-btn">Check item</div>
                  </a>
                );
              })
            ) : (
              <Swiper freeMode slidesPerView={"auto"} spaceBetween={32}>
                {items?.map((item, index) => {
                  // const link = item?.link?.replaceAll("YOURUSERID", userID);
                  const img = item?.["Image Url"];

                  const link = isShareUrl
                    ? `https://www.shareasale.com/m-pr.cfm?merchantID=97366&userID=3585269&productID=${item?.Id}`
                    : item?.link?.replaceAll("YOURUSERID", userID);
                  // const price = item?.Price;
                  // const Name = item?.Name;

                  return (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        className="link-to-product"
                        href={link}
                      >
                        <img
                          alt={!!name ? name : "no title"}
                          border="0"
                          src={img}
                        />
                      </a>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
          {hasMore ? (
            <InView onChange={loadItems}>
              <div className="buttons-wrap flex-it flex-align-item-center flex-justify-center">
                {/* <div className="checkout-btn" onClick={loadItems}>
              Load More
            </div> */}
                <ReactSVG src={loader1} className="svg-loader" />
              </div>
            </InView>
          ) : (
            <></>
          )}
        </>
      )
    );
};

export default SwiperDataFeedReader;
